module.exports = __webpack_public_path__ + "img/left-arrow.d0aa519f.svg";